import useFlightPurchaseDetails from 'hooks/Flights/useFlightPurchaseDetails'

// useFlightPurchaseDetails expects a full order. Pass this null-object while the
// order is still loading, or for non-flight rows, so no flight-details request fires.
const EMPTY_ORDER = { id: '', flightItems: [] } as unknown as App.Order

// Membership activity: resolve the flight route title shown on the My Escapes tile
// (full airport names + countries, e.g. "Melbourne Intl - Tullamarine, Australia to
// London Heathrow, United Kingdom") by reusing the tile's own hook. Pass undefined
// for non-flight rows to skip the flight-details fetch.
export default function useOrderFlightName(order: App.Order | undefined) {
  const { flightsName, fetching } = useFlightPurchaseDetails(order ?? EMPTY_ORDER)
  return { flightName: flightsName, fetching: Boolean(fetching) }
}
